import { z } from 'zod';

export const ReleaseManageSchema = z.object({
  version: z
    .string({ message: 'main.releases.components.manage.form.version.error' })
    .min(1, { message: 'main.releases.components.manage.form.version.error' })
    .nullable(),
  releasedAt: z
    .date({ message: 'main.releases.components.manage.form.releasedAt.error' }),
  content: z
    .string({ message: 'main.releases.components.manage.form.content.error' })
    .min(1, { message: 'main.releases.components.manage.form.content.error' })
    .nullable(),
  isActive: z
    .boolean({ message: 'main.releases.components.manage.form.status.error' }),
});

export type ReleaseManageFormData = z.infer<typeof ReleaseManageSchema>;
